<app-expansion-panel
  title="How often do you purchase a new device?"
  [description]="userEntries.length > 0 ? 'answered' : 'not answered'"
  [descriptionClasses]="
    userEntries.length > 0
      ? ['question', 'answered']
      : ['question', 'unanswered']
  "
  [expanded]="true"
  >
  <p>
    Please indicate the number of <strong>years</strong> you typically use each device before replacing it with a new one (leave blank if you don't use that device):
  </p>
  @for (product of products; track product) {
    <div class="category-item">
      <p class="category-item-name">
        {{ product.text.text_en ? product.text.text_en : product.text.text_de }}
      </p>
      <div class="increment-decrement-controls">
        <button
          (click)="decrementYear(product.id)"
          class="increment-decrement-button"
          >
          -
        </button>
        <input
          type="text"
          matInput
          [value]="getYearForProduct(product.id) || ''"
          disabled
          class="amount-indicator year-indicator"
          />
        <button
          (click)="incrementYear(product.id)"
          class="increment-decrement-button"
          >
          +
        </button>
      </div>
    </div>
  }
</app-expansion-panel>
